<template>
	<div style="padding: 20px;">
		<DescriptionList title="" :col="6" :data="basicInfo">
			<!-- 使用作用域插槽自定义复杂内容 -->
			<template #status="{ record }">
				<Tag :type="record.value === '激活' ? 'success' : 'default'">
					{{ record.value }}
				</Tag>
			</template>
		</DescriptionList>
	</div>
</template>

<script>
	import DescriptionList from './DescriptionList.vue'; // 假设路径

	export default {
		components: {
			DescriptionList
		},
		props: {
			row: {
				type: Object,
				default: () => {}
			},
		},
		data() {
			return {
				basicInfo: [
					// {
					// 	label: 'ID',
					// 	key: 'Id',
					// 	value: this.row.Id
					// },
					{
						label: this.$tt('设备序列号'),
						key: 'EquipmentSerialNo',
						value: this.row.EquipmentSerialNo,
					},
					{
						label: this.$tt('充电枪编码'),
						key: 'ConnectorNo',
						value: this.row.ConnectorNo,
					}, // 自定义占位
					{
						label: this.$tt('订单单号'),
						key: 'OrderNo',
						value: this.row.OrderNo
					},
					{
						label: this.$tt('充电费用'),
						key: 'ChargeCost',
						value: this.row.ChargeCost.toFixed(2)
					},
					{
						label: this.$tt('充电电费'),
						key: 'ElecCost',
						value: this.row.ElecCost.toFixed(2)
					},
					{
						label: this.$tt('充电服务费'),
						key: 'ServiceCost',
						value: this.row.ServiceCost.toFixed(2)
					},
					{
						label: this.$tt('充电前余额'),
						key: 'BeginBalance',
						value: this.row.BeginBalance.toFixed(2)
					},
					{
						label: this.$tt('当前充电记录索引'),
						key: 'RecordIndex',
						value: this.row.RecordIndex
					},
					{
						label: this.$tt('充电记录总条数'),
						key: 'RecordTotal',
						value: this.row.RecordTotal
					},
					{
						label: this.$tt('充电策略'),
						key: 'ChargePolicy',
						value: this.row.ChargePolicy === 1 ? '按时间充电' : this.row.ChargePolicy === 2 ? '按金额充电' : this.row.ChargePolicy === 3 ? '按电量' : '充满自停',
						render: (h, params) => {
							const val = params.row.ChargePolicy;
							return h('div', {}, val === 1 ? '按时间充电' : val === 2 ? '按金额充电' : val === 3 ? '按电量' : '充电自停');
						}
					},
					{
						label: this.$tt('充电策略参数'),
						key: 'ChargePolicyParam',
						//value: this.row.ChargePolicyParam
						value: this.row.ChargePolicy === 1 ? this.formatSeconds(this.row.ChargePolicyParam) : this.row.ChargePolicy === 3 ? ((this.row.ChargePolicyParam * 0.01).toFixed(2) + this.$tt('度')) : ((this.row.ChargePolicyParam * 0.01).toFixed(2) + this.$tt('元'))
					},
					{
						label: this.$tt('预充电压'),
						key: 'PreChargeVol',
						value: this.row.ext.PreChargeVol
					},
					{
						label: this.$tt('预充绝缘值'),
						key: 'PreChargeInsulReg',
						value: this.row.ext.PreChargeInsulReg
					},
					{
						label: this.$tt('最高输出电压'),
						key: 'HiOutputVol',
						value: this.row.ext.HiOutputVol
					},
					{
						label: this.$tt('最低输出电压'),
						key: 'LoOutputVol',
						value: this.row.ext.LoOutputVol
					},
					{
						label: this.$tt('最高需求电压'),
						key: 'HiDemandVol',
						value: this.row.ext.HiDemandVol
					},
					{
						label: this.$tt('最高允许电压'),
						key: 'HiAllowVol',
						value: this.row.ext.HiAllowVol
					},
					{
						label: this.$tt('最高单体电压'),
						key: 'HiCellVol',
						value: this.row.ext.HiCellVol
					},
					{
						label: this.$tt('最低单体电压'),
						key: 'LoCellVol',
						value: this.row.ext.LoCellVol
					},
					{
						label: this.$tt('最高输出电流'),
						key: 'HiOutputCur',
						value: this.row.ext.HiOutputCur
					},
					{
						label: this.$tt('最高需求电流'),
						key: 'HiDemandCur',
						value: this.row.ext.HiDemandCur
					},
					{
						label: this.$tt('最高允许电流'),
						key: 'HiAllowCur',
						value: this.row.ext.HiAllowCur
					},
					{
						label: this.$tt('最高输出功率'),
						key: 'HiPower',
						value: this.row.ext.HiPower
					},
					{
						label: this.$tt('最高温度'),
						key: 'HiTemp',
						value: this.row.ext.HiTemp
					},
					{
						label: this.$tt('最高单体电池温度'),
						key: 'HiTempCell',
						value: this.row.ext.HiTempCell
					},
					{
						label: this.$tt('最低单体电池温度'),
						key: 'LoTempCell',
						value: this.row.ext.LoTempCell
					},
					{
						label: this.$tt('暂停充电次数'),
						key: 'ChargePauseNum',
						value: this.row.ext.ChargePauseNum
					},
					{
						label: this.$tt('是否双枪同充一台车'),
						key: 'TwoGunOneCar',
						value: this.row.ext.TwoGunOneCar ? (this.row.ext.TwoGunOneCar === 1 ? 'true' : 'false') : this.row.ext.TwoGunOneCar
					},
					{
						label: this.$tt('电损系数'),
						key: 'LossRate',
						value: this.row.ext.LossRate
					},
					{
						label: this.$tt('运行模式'),
						key: 'RunMode',
						value: this.row.ext.RunMode
					},
					{
						label: this.$tt('重卡协议'),
						key: 'HeavyTruckProtocol',
						value: this.row.ext.HeavyTruckProtocol
					},
					{
						label: this.$tt('DLB 限制功率最大值'),
						key: 'DlbLimitMax',
						value: this.row.ext.DlbLimitMax
					},
					{
						label: this.$tt('DLB 限制功率最小值'),
						key: 'DlbLimitMin',
						value: this.row.ext.DlbLimitMin
					},
				]
			};
		},
		methods: {
			formatSeconds(seconds) {
				const h = Math.floor(seconds / 3600);
				const m = Math.floor((seconds % 3600) / 60);
				const s = seconds % 60;
				// padStart补零，不足两位前面补0
				return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
			}
		}
	};
</script>
